import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	buttonText: {
		id: 'issue-view-foundation.issue-actions.compal-button-dropdown-group.trigger-button.button-text',
		defaultMessage: 'Open command palette',
		description: 'Label for the command palette button that opens up the command palette',
	},
});
